import { useParams } from "react-router-dom";
import { FormActions } from "../../../components/common/FormActions";
import { BooleanTags } from "../../../components/common/registerUtils";
import { API_YOYA_CHARGES } from "../../../utils/apis";
import {
  beautify,
  createEditAction,
  createViewAction,
  formatCurrency,
  formatDateTime,
  getForm,
  getRegister,
} from "../../../utils/helpers";
import { URL_YOYA_CHARGES } from "../../../utils/urls";

const url = URL_YOYA_CHARGES;

// REGISTER
export const useYoyaCharges = () => {
  const { id } = useParams<{ id?: string }>();

  const tableColumns = () => [
    { id: "fee", header: "Fee" },
    { id: "lower_limit", header: "Lower Limit" },
    { id: "upper_limit", header: "Upper limit" },
    {
      id: "fee_type",
      header: "Fee type",
      filter: {
        type: "select",
        options: [
          { id: "fixed", name: "Fixed" },
          { id: "percentage", name: "Percentage" },
          { id: "tiered", name: "Tiered" },
        ],
      },
    },
    {
      id: "is_percent",
      header: "Is percent",
      filter: {
        type: "select",
        placeholder: "Select...",
        options: [
          { id: "false", name: "False" },
          { id: "true", name: "True" },
        ],
      },
    },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        is_percent: <BooleanTags status={item?.is_percent} />,
        fee: item?.fee,
        lower_limit: formatCurrency(item?.lower_limit),
        upper_limit: formatCurrency(item?.upper_limit),
        fee_type: beautify(item?.fee_type),
        actions: (
          <FormActions
            actions={[
              createEditAction(url, item?.id),
              createViewAction(url, item?.id),
            ]}
          />
        ),
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "OnePayX charges Details",
          fields: {
            ...item,
            is_percent: item?.is_percent === true ? "True" : "False",
            is_active: item?.is_active === true ? "True" : "False",
            fee_type: beautify(item?.fee_type),
            created_at: formatDateTime(item?.created_at),
            updated_at: formatDateTime(item?.updated_at),
          },
        },
      ],
    };
  };

  const formRoute = getForm(url);

  const endpoint = `transact/yoya-charges/${id}/logs/`;

  return { tableData, tableColumns, formRoute, viewData, endpoint };
};

// FORM
export const useYoyaChargesForm = ({ form }) => {
  const sections: any = [
    {
      title: "OnePayX Charges Details",
      fields: [
        {
          field_name: "fee_type",
          type: "select",
          label: "Fee type",
          props: { required: true },
          options_data: [
            { id: "fixed", name: "Fixed" },
            { id: "percentage", name: "Percentage" },
            { id: "tiered", name: "Tiered" },
          ],
        },
        {
          field_name: "fee_amount",
          label: "Fee Amount",
          type: "number",
          props: { required: true },
        },
        {
          field_name: "is_percent",
          type: "select",
          label: "Is Percent",
          props: { required: true },
          options_data: [
            { id: true, name: "True" },
            { id: false, name: "False" },
          ],
          visible: form?.fee_type === "percentage",
        },
        {
          field_name: "lower_limit",
          label: "Lower Limit",
          type: "number",
          props: { required: true, disabled: true },
          visible: form?.fee_type === "tiered",
        },
        {
          field_name: "upper_limit",
          label: "Upper Limit",
          type: "number",
          props: { required: true, disabled: true },
          visible: form?.fee_type === "tiered",
        },

        // {
        //   field_name: "is_active",
        //   type: "select",
        //   label: "Activate",
        //   props: { required: true },
        //   options_data: [
        //     { id: true, name: "True" },
        //     { id: false, name: "False" },
        //   ],
        // },
      ],
    },
  ];

  const redirect = getRegister(url);

  return { sections, redirect, onSubmit: submitYoyaCharges };
};

// SUBMIT
export function submitYoyaCharges(payload: any, id: string | number) {
  //   UPDATE
  if (id) {
    return {
      id,
      api: API_YOYA_CHARGES,
      params: {
        ...payload,
      },
    };
  }
  //   CREATE
  return {
    api: API_YOYA_CHARGES,
    params: {
      ...payload,
    },
  };
}
